import { Home, Refresh } from '@mui/icons-material';
import { Avatar, Box, Button, Stack } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { Link, useRouteError } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import {
  getDynamicImportErrorMessage,
  isStaleBuildAssetError,
  recoverFromStaleBuildAssetError,
} from '../../utility/deploy/staleBuildRecovery';

export const RouteErrorElement = () => {
  const error = useRouteError();
  const isStaleBuildError = useMemo(() => isStaleBuildAssetError(error), [error]);

  useEffect(() => {
    recoverFromStaleBuildAssetError(error, 'react_router.error_element');
  }, [error]);

  const title = isStaleBuildError ? 'Actualizando aplicación' : 'Algo salió mal';
  const message = isStaleBuildError
    ? 'Detectamos que la pantalla intentó cargar archivos de una versión anterior. Recarga la aplicación para tomar el último despliegue.'
    : 'No pudimos cargar esta página. Tus datos están seguros.';

  return (
    <Box className="min-h-screen flex items-center justify-center p-8 bg-gradient-to-br from-slate-50 to-blue-50">
      <Box className="max-w-md w-full p-8 bg-white rounded-3xl shadow-2xl border border-slate-200">
        <Box className="flex items-center justify-center">
          <Avatar className="!h-[8rem] !w-[8rem]" alt="Logo" src={logo} />
        </Box>

        <h1 className="text-lg font-bold text-slate-900 mb-4 text-center tracking-tight">
          {title}
        </h1>

        <p className="text-lg text-slate-600 mb-8 text-center leading-relaxed">{message}</p>

        {import.meta.env.DEV ? (
          <p className="text-xs text-slate-400 mb-6 break-words">
            {getDynamicImportErrorMessage(error)}
          </p>
        ) : null}

        <Stack
          className="col-span-2"
          direction="row"
          gap={2}
          sx={{
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <Button
            component={Link}
            to="/"
            variant="contained"
            fullWidth
            color="primary"
            startIcon={<Home />}
            sx={{
              mt: 2,
              borderRadius: '2rem',
            }}
          >
            Ir a inicio
          </Button>

          <Button
            variant="contained"
            fullWidth
            color="primary"
            startIcon={<Refresh />}
            sx={{
              mt: 2,
              borderRadius: '2rem',
            }}
            onClick={() => window.location.reload()}
          >
            Recargar aplicación
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};
